// @flow strict
import type {
  ReferralSetting,
  ReferralSettingApiRequest,
} from 'src/types/referral-v2';
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useSelector, useDispatch} from 'react-redux';
import {useInflight} from 'src/hooks/redux';
import {useReferralsPaypalPayment} from 'src/hooks/product-flags';
//$FlowFixMe[nonstrict-import]
import usePrivilege from 'src/hooks/usePrivilege';
// $FlowFixMe[nonstrict-import]
import {getReferralNotification} from 'src/utils/referral-v2.js';
import classify from 'src/utils/classify';
import {
  updateReferralSettings,
  getReferralSettings,
} from 'src/action-creators/referral-v2/referral-settings.js';
import {selectReferralSetting} from 'src/selectors/referral-settings.js';
import {
  SubTitleSmall,
  FormLabelSmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {
  Card,
  CardHeader,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {Toggle} from '@spaced-out/ui-design-system/lib/components/Toggle';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';
import ReferralPaymentSettings from 'src/components/referral-v2/settings/payments-settings.jsx';
import css from 'src/components/referral-v2/configure/configure.css';


const Notifications = (): React.Node => {
  const dispatch = useDispatch();
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const REFERRAL_NOTIFICATION = getReferralNotification(t);
  const isReferralPaymentsEnabled = useReferralsPaypalPayment();

  const referralSettings: ?ReferralSetting = useSelector(selectReferralSetting);
  const isNotificationLoading = useInflight(getReferralSettings());

  const hasSuperAdminAccess = usePrivilege('ADMIN_REFERRALS_V2');

  const onToggle = (fieldName: string, value: boolean) => {
    const payload: ReferralSettingApiRequest[] = [
      {category: 'notifications', configs: [{key: fieldName, value}]},
    ];
    dispatch(updateReferralSettings(payload));
  };

  return (
    <div className={css.generalNotificationsContent}>
      <Card type="primary">
        <CardHeader className={css.stepperCardHeader}>
          <SubTitleSmall className={css.toggleLabel}>
            {t('Notification_Settings', 'Notification Settings')}
          </SubTitleSmall>
          <div
            className={classify(css.notificationContent, {
              [css.userNotificationContent]: !hasSuperAdminAccess,
            })}
          >
            <SubTitleSmall>{t('For_Me', 'For Me')}</SubTitleSmall>
            {hasSuperAdminAccess && (
              <SubTitleSmall>
                {t('For_Referrers', 'For Referrers')}
              </SubTitleSmall>
            )}
          </div>
        </CardHeader>
        <CardContent
          className={classify(css.contentSection, css.shareModalBody)}
        >
          {REFERRAL_NOTIFICATION.map((notification) => (
            <div key={notification.agent}>
              <FormLabelSmall className={css.toggleLabel}>
                {notification.label}
              </FormLabelSmall>
              <div
                className={classify(css.notificationContent, {
                  [css.userNotificationContent]: !hasSuperAdminAccess,
                })}
              >
                <Toggle
                  classNames={{wrapper: css.emptyToggle}}
                  onChange={(e) => onToggle(notification.agent, e.checked)}
                  checked={referralSettings?.notifications[notification.agent]}
                  disabled={isNotificationLoading}
                />
                {hasSuperAdminAccess &&
                  (notification.recruiter ===
                  'referral_request_recruiter_notification' ? (
                    <Tooltip
                      body={t(
                        'This_option_can\'t_be_enabled',
                        'This option can\'t be enabled',
                      )}
                      bodyMaxLines={2}
                      placement="top"
                    >
                      <div>
                        <Toggle
                          classNames={{wrapper: css.emptyToggle}}
                          checked={false}
                          disabled={true}
                        />
                      </div>
                    </Tooltip>
                  ) : (
                    <Toggle
                      classNames={{wrapper: css.emptyToggle}}
                      onChange={(e) =>
                        onToggle(notification.recruiter, e.checked)
                      }
                      checked={
                        referralSettings?.notifications[notification.recruiter]
                      }
                      disabled={isNotificationLoading}
                    />
                  ))}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
      {isReferralPaymentsEnabled && hasSuperAdminAccess && (
        <ReferralPaymentSettings />
      )}
    </div>
  );
};

export default Notifications;
